import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Spinner } from "react-bootstrap";
import { postRequest } from "../../system/server-call";
import { ToastifyService } from "../../services";

const CompanySignup = () => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone_number: "",
    address: "",
  });

  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.id]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (!formData.name.trim()) {
      setError("Company Name is required.");
      return;
    }
    if (!formData.email.trim()) {
      setError("Company Email is required.");
      return;
    }

    setLoading(true);
    try {
      await postRequest("auth/register-company", formData);
      setDone(true);
      ToastifyService.showSuccess(
        "Company registered successfully! A password setup link has been sent to your email."
      );
    } catch (err) {
      const msg =
        err?.response?.data?.message ||
        "Failed to register company. Please try again.";
      setError(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page-wrapper pt-5">
      <div className="auth-page-content">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-8 col-lg-6 col-xl-5">
              <div className="card mt-4 card-bg-fill">
                <div className="card-body p-4">
                  {done ? (
                    <div className="text-center py-4">
                      <div
                        style={{
                          width: 64,
                          height: 64,
                          borderRadius: "50%",
                          background: "#d1fae5",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          margin: "0 auto 16px",
                        }}
                      >
                        <i
                          className="ri-checkbox-circle-line"
                          style={{ fontSize: 36, color: "#059669" }}
                        />
                      </div>
                      <h5 className="text-success mb-2">Company Registered!</h5>
                      <p className="text-muted mb-4">
                        We have sent a <strong>Create Password</strong> link to{" "}
                        <strong className="text-dark">{formData.email}</strong>.
                        Please check your inbox to activate your account.
                      </p>
                      <Link to="/login" className="btn btn-primary w-100">
                        Back to Login
                      </Link>
                    </div>
                  ) : (
                    <>
                      <div className="text-center mt-2">
                        <h5 className="text-primary">Register Your Company</h5>
                        <p className="text-muted">
                          Sign up today to manage compliance & employees.
                        </p>
                      </div>

                      <div className="p-2 mt-4">
                        <form onSubmit={handleSubmit} className="h-auto">
                          {/* Company Name */}
                          <div className="mb-3">
                            <label htmlFor="name" className="form-label">
                              Company Name <span className="text-danger">*</span>
                            </label>
                            <input
                              type="text"
                              id="name"
                              className="form-control"
                              placeholder="Enter company name"
                              value={formData.name}
                              onChange={handleChange}
                              required
                            />
                          </div>

                          {/* Company Email */}
                          <div className="mb-3">
                            <label htmlFor="email" className="form-label">
                              Company Email <span className="text-danger">*</span>
                            </label>
                            <input
                              type="email"
                              id="email"
                              className="form-control"
                              placeholder="name@company.com"
                              value={formData.email}
                              onChange={handleChange}
                              required
                            />
                          </div>

                          {/* Phone Number */}
                          <div className="mb-3">
                            <label htmlFor="phone_number" className="form-label">
                              Phone Number
                            </label>
                            <input
                              type="text"
                              id="phone_number"
                              className="form-control"
                              placeholder="Enter contact phone number"
                              value={formData.phone_number}
                              onChange={handleChange}
                            />
                          </div>

                          {/* Address */}
                          <div className="mb-3">
                            <label htmlFor="address" className="form-label">
                              Address
                            </label>
                            <input
                              type="text"
                              id="address"
                              className="form-control"
                              placeholder="Enter company address"
                              value={formData.address}
                              onChange={handleChange}
                            />
                          </div>

                          {error && (
                            <div className="alert alert-danger py-2" role="alert">
                              {error}
                            </div>
                          )}

                          <div className="mt-4">
                            <button
                              type="submit"
                              className="btn btn-success w-100"
                              disabled={loading}
                            >
                              {loading ? (
                                <>
                                  <Spinner
                                    animation="border"
                                    size="sm"
                                    className="me-2"
                                  />
                                  Registering...
                                </>
                              ) : (
                                "Register Company"
                              )}
                            </button>
                          </div>
                        </form>
                      </div>
                    </>
                  )}
                </div>
              </div>

              <div className="mt-4 text-center">
                <p className="mb-0 text-muted">
                  Already registered?{" "}
                  <Link
                    to="/login"
                    className="fw-semibold text-primary text-decoration-underline"
                  >
                    Sign In
                  </Link>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CompanySignup;
